import PropTypes from "prop-types"
import {
  getLocalizedDate,
  getMonthAbbreviation,
  getDayName,
  getTimezoneName,
  getFormattedTime,
} from "lib/functions"
import * as css from "./ScheduledDemoInfo.module.css"

function ScheduledDemoInfo({ date, timezone }) {
  const time = getLocalizedDate(date, timezone)
  const day = time.getDate()
  const month = getMonthAbbreviation(time)
  const weekDay = getDayName(time)
  const timezoneName = getTimezoneName(time, timezone)
  const hour = getFormattedTime(time)
  return (
    <div className={css.info}>
      <div className={css.wrapper}>
        {month}
        <br />
        {day}
      </div>
      <div className={css.content}>
        <div className={css.suptitle}>{weekDay}</div>
        <div className={css.title}>
          {hour} {timezoneName}
        </div>
      </div>
    </div>
  )
}

ScheduledDemoInfo.propTypes = {
  date: PropTypes.string,
  timezone: PropTypes.string,
}

export default ScheduledDemoInfo
